import { Map } from 'immutable';
import clone from 'clone';
import actions from './actions';
import events from '../../containers/Calendar/demoEvents';

export const dateToString = date =>
  date
    .toString()
    .split(' ')
    .slice(0, 4)
    .join(' ');
const filterEvents = events => {
  const mobileEvents = [];
  const mobileDailyEvents = {};
  events.forEach(event => {
    const newStartString = dateToString(event.booking.dateStart);
    if (!mobileDailyEvents[newStartString]) {
      mobileDailyEvents[newStartString] = [];
      mobileEvents.push({
        allDay: true,
        title: '',
        modalVisible: false,
        selectedData: undefined,
        selectedDate: null,
        start: new Date(newStartString),
        end: new Date(newStartString)
      });
    }
    mobileDailyEvents[newStartString].push(event);
  });
  return { mobileEvents, mobileDailyEvents };
};
const initState = new Map({
  loading: false,
  view: 'month',
  events: [],
  mobileEvents: [],
  mobileDailyEvents: []
});

export default function(state = initState, action) {
  switch (action.type) {
    case actions.CALENDAR_VIEW:
      return state.set('view', action.view);
    case actions.CALENDAR_EVENTS: {
      const events = action.events;
      const { mobileEvents, mobileDailyEvents } = filterEvents(clone(events));
      return state
        .set('events', events)
        .set('mobileEvents', mobileEvents)
        .set('mobileDailyEvents', mobileDailyEvents);
    }
    case actions.SET_PROPERTY_VIEWING_DATA: {
      const events = action.events;
      const { mobileEvents, mobileDailyEvents } = filterEvents(clone(events));
      return state
        .set('events', events)
        .set('mobileEvents', mobileEvents)
        .set('mobileDailyEvents', mobileDailyEvents);
    }
    case actions.CHANGE_SELECTED_DATE:
      return state.set('selectedDate', action.selectedDate);
    case actions.ON_SELECT_DATE:
      return state
        .set('selectedData', action.selectedData)
        .set('modalVisible', action.modalVisible);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/calendar/reducer.js